module.exports = __webpack_public_path__ + "img/glzx.5d389576.png";